import PageHeaderCC from './PageHeaderCC';

export default PageHeaderCC;
